export type Profile = {
  imageUrl: string;
  name: string;
  position: string;
  quote: string;
  linkedinUrl?: string;
};

export const testimonialCompaniesProfiles: Profile[] = [
  {
    name: "Thilo Thies",
    position: "Founder @ EckRad",
    quote:
      "Hydra helped me finish my automations so I could focus on what I do best: selling bikes.",
    imageUrl: "/Testimonials/Thilo.png",
    linkedinUrl: "https://www.linkedin.com/in/thilo-thies-2a1733176/",
  },
  {
    name: "Andrew Wilkinson",
    position: "Founder @ Unity.FM",
    quote:
      "I was going crazy, unable to find a Svelte and Flask dev that could finish my project, until Hydra found me one.",
    imageUrl: "/Testimonials/Andrew.png",
    linkedinUrl: "https://www.linkedin.com/in/andrew-wilkinson-847a84113/",
  },
  {
    name: "Nejmo Serraoui",
    position: "Founder @ Pre-Round Club",
    quote:
      "Vibe coding helped me prototype my project, but Hydra actually gave me the confidence to release it publicly.",
    imageUrl: "/Testimonials/Nejmo.png",
    linkedinUrl: "https://www.linkedin.com/in/nejmo-serraoui-8a4a6115b/",
  },
  {
    name: "Jesse Strober",
    position: "Founder @ SnapRent",
    quote:
      "Instead of interviewing 50 developers on Upwork, I was matched instantly with a great dev.",
    imageUrl: "/Testimonials/Jesse.png",
    linkedinUrl: "https://www.linkedin.com/in/jessestrober/",
  },
];
